module.exports = __webpack_public_path__ + "img/half-logo.ed04f313.svg";